import type {Address, BillingDetails} from '../types';

// PayPal Buttons SDK onShippingAddressChange callback data → Address
// Callback data: { shippingAddress: { city, state, countryCode, postalCode } } (redacted, no street)
export const normalizePayPalCallbackAddress = (data: any): Address => ({
  city: data?.shippingAddress?.city || undefined,
  state: data?.shippingAddress?.state || undefined,
  zip: data?.shippingAddress?.postalCode || undefined,
  country: data?.shippingAddress?.countryCode || undefined
});

// PayPal Orders API shipping → Address (used for post-approval order details)
// Shipping object: { name: {full_name}, address: {address_line_1, address_line_2, admin_area_2, admin_area_1, postal_code, country_code} }
export const normalizePayPalShipping = (shipping: any): Address => ({
  line1: shipping?.address?.address_line_1 || undefined,
  line2: shipping?.address?.address_line_2 || undefined,
  city: shipping?.address?.admin_area_2 || undefined,
  state: shipping?.address?.admin_area_1 || undefined,
  zip: shipping?.address?.postal_code || undefined,
  country: shipping?.address?.country_code || undefined
});

// PayPal shipping → BillingDetails (includes recipient name from shipping object)
export const normalizePayPalShippingDetails = (shipping: any): BillingDetails => ({
  name: shipping?.name?.full_name || undefined,
  address: normalizePayPalShipping(shipping)
});

// PayPal payer → BillingDetails
// PayPal payer object: { name: {given_name, surname}, email_address, phone: {phone_number: {national_number}}, address: {address_line_1, ...} }
export const normalizePayPalPayer = (payer: any): BillingDetails => {
  const names = [payer?.name?.given_name, payer?.name?.surname].filter(Boolean);
  return {
    name: names.length > 0 ? names.join(' ') : undefined,
    email: payer?.email_address || undefined,
    phone: payer?.phone?.phone_number?.national_number || undefined,
    address: {
      line1: payer?.address?.address_line_1 || undefined,
      line2: payer?.address?.address_line_2 || undefined,
      city: payer?.address?.admin_area_2 || undefined,
      state: payer?.address?.admin_area_1 || undefined,
      zip: payer?.address?.postal_code || undefined,
      country: payer?.address?.country_code || undefined
    }
  };
};
